/*
 * streets Sagas
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 27-May-2025
 */

import { put, take, call, all } from 'redux-saga/effects'
import * as addressAction from 'Store/actions/address'
import * as AddressApi from 'Api/address/address'

function * getCountriesSaga (payload) {
  yield put(addressAction.getCountries.request({}, { loading: true }))
  const { error, response } = yield call(AddressApi.getCountries, payload)

  if (!error) {
    yield put(addressAction.getCountries.success(response))
  } else {
    yield put(addressAction.getCountries.failure(error, { hideErrorPopup: true, ...response }))
  }
}
function * getStreetsSaga (payload) {
  yield put(addressAction.getStreets.request(payload, { loading: true }))
  const { error, response } = yield call(AddressApi.getStreets, payload)
  if (!error) {
    yield put(addressAction.getStreets.success({ ...response, isSecondary: payload.isSecondary }))
  } else {
    yield put(addressAction.getStreets.failure(error, { hideErrorPopup: true, ...response }))
  }
}
function * getProvincesSaga (payload) {
  yield put(addressAction.getProvinces.request(payload, { loading: true }))
  const { error, response } = yield call(AddressApi.getProvinces, payload)

  if (!error) {
    yield put(addressAction.getProvinces.success(response))
  } else {
    yield put(addressAction.getProvinces.failure(error, { hideErrorPopup: true, ...response }))
  }
}
function * getMunicipalitiesSaga (payload) {
  yield put(addressAction.getMunicipalities.request(payload, { loading: true }))
  const { error, response } = yield call(payload.withCustom ? AddressApi.getMunicipalitiesWithCustom : AddressApi.getMunicipalities, payload)
  if (!error) {
    yield put(addressAction.getMunicipalities.success({ ...response, isSecondary: payload.isSecondary }))
  } else {
    yield put(addressAction.getMunicipalities.failure(error, { hideErrorPopup: true, ...response }))
  }
}
function * getCheckForeignMunicipalitiesSaga (payload) {
  yield put(addressAction.getCheckForeignMunicipalities.request(payload, { loading: true }))
  const { error, response } = yield call(AddressApi.getCheckForeignMunicipality, payload)
  if (!error) {
    yield put(addressAction.getCheckForeignMunicipalities.success(response))
  } else {
    yield put(addressAction.getCheckForeignMunicipalities.failure(error, { hideErrorPopup: true, ...response }))
  }
}

// @generator saga

// @generator saga:watch

function * watchGetCountries () {
  while (true) {
    const { payload } = yield take(addressAction.actionTypes.DO_GET_COUNTRIES)
    yield call(getCountriesSaga, payload)
  }
}
function * watchGetStreets () {
  while (true) {
    const { payload } = yield take(addressAction.actionTypes.DO_GET_STREETS)
    yield call(getStreetsSaga, payload)
  }
}
function * watchGetProvinces () {
  while (true) {
    const { payload } = yield take(addressAction.actionTypes.DO_GET_PROVINCES)
    yield call(getProvincesSaga, payload)
  }
}
function * watchGetMunicipalities () {
  while (true) {
    const { payload } = yield take(addressAction.actionTypes.DO_GET_MUNICIPALITIES)
    yield call(getMunicipalitiesSaga, payload)
  }
}
function * watchGetCheckForeignMunicipalitiesSaga () {
  while (true) {
    const { payload } = yield take(addressAction.actionTypes.DO_GET_CHECK_FOREIGN_MUNICIPALITIES)
    yield call(getCheckForeignMunicipalitiesSaga, payload)
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function * rootSaga () {
  yield all([
    watchGetCountries(),
    watchGetStreets(),
    watchGetProvinces(),
    watchGetMunicipalities(),
    watchGetCheckForeignMunicipalitiesSaga()
    // @generator saga:fork
  ])
}
